import { valueToForm, arrayToForm } from '../../../web-app-components/utils/formInputs';

import parseCoordinates from '../../../utils/parseCoordinates';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const coordinatesToForm = (coordinates) => {
  if (coordinates == null) {
    return null;
  }
  // If already in form shape (e.g. from API or rehydration), pass through
  if (
    typeof coordinates === 'object' &&
    typeof coordinates.lat === 'number' &&
    typeof coordinates.lng === 'number'
  ) {
    return { lng: coordinates.lng, lat: coordinates.lat };
  }
  const lngLatArr = parseCoordinates(
    typeof coordinates === 'string' ? coordinates : String(coordinates)
  );
  if (!lngLatArr || lngLatArr.length < 2) {
    return null;
  }
  const [lng, lat] = lngLatArr;
  return { lng, lat };
};

const formToCoordinates = (coordinates) =>
  `${coordinates.lat}, ${coordinates.lng}`;

export const toForm = ({
  Title,
  Description,
  RouteStartCoordinates,
  GXPFile,
  Video,
  Images,
  VideoURL,
  Region,
  District,
  Length,
  Duration,
  VirtualAudioGuideExists,
  Paid,
  PaidAmount,
  SuitableFor,
  TravelMethod,
  objects,
  CoordinateAudioGuides,
  locale: routeLocale,
}) => ({
  locale: routeLocale || 'lt-LT',
  Title: valueToForm(Title || ''),
  Description: valueToForm(Description || ''),
  RouteStartCoordinates: coordinatesToForm(RouteStartCoordinates),
  GXPFile: GXPFile ? {
    id: GXPFile.id,
    name: `${GXPFile.name}${GXPFile.ext || ''}`,
    url: `${SERVER_URL}${GXPFile.url || ''}`,
  } : null,
  Video: Video ? {
    id: Video.id,
    name: `${Video.name}${Video.ext || ''}`,
    url: `${SERVER_URL}${Video.url || ''}`,
  } : null,
  Images: arrayToForm(Images || []).map((img) => ({
    id: img.id,
    name: `${img.name}${img.ext || ''}`,
    url: `${SERVER_URL}${img.url || ''}`,
  })),
  VideoURL: valueToForm(VideoURL),
  Region: valueToForm(Region),
  District: valueToForm(District),
  Length: valueToForm(Length),
  Duration: valueToForm(Duration),
  VirtualAudioGuideExists: valueToForm(VirtualAudioGuideExists || false),
  Paid: valueToForm(Paid || false),
  PaidAmount: valueToForm(PaidAmount),
  SuitableFor: valueToForm(SuitableFor),
  TravelMethod: valueToForm(TravelMethod),
  objects: arrayToForm(objects || []).map(({ id }) => id),
  CoordinateAudioGuides: (CoordinateAudioGuides || []).map((guide) => ({
    Coordinates: guide.Coordinates || '',
    Name: guide.Name || '',
    object: guide.object != null ? (guide.object?.id ?? guide.object) : null,
    subcategory: guide.subcategory != null ? (guide.subcategory?.id ?? guide.subcategory) : null,
    AudioFile: guide.AudioFile ? {
      id: guide.AudioFile.id,
      name: `${guide.AudioFile.name}${guide.AudioFile.ext || ''}`,
      url: `${SERVER_URL}${guide.AudioFile.url || ''}`,
    } : null,
  })),
});

const mediaIdFromForm = (value) =>
  value == null
    ? null
    : typeof value === 'number'
    ? value
    : value && typeof value.id === 'number'
    ? value.id
    : null;

export const fromForm = ({
  locale,
  Title,
  Description,
  RouteStartCoordinates,
  GXPFile,
  Video,
  Images,
  VideoURL,
  Region,
  District,
  Length,
  Duration,
  VirtualAudioGuideExists,
  Paid,
  PaidAmount,
  SuitableFor,
  TravelMethod,
  objects,
  CoordinateAudioGuides,
}) => {
  const selectedLocale = locale || 'lt-LT';

  return {
    locale: selectedLocale,
    Title: Title || '',
    Description: Description || '',
    RouteStartCoordinates: RouteStartCoordinates ? formToCoordinates(RouteStartCoordinates) : null,
    GXPFile: mediaIdFromForm(GXPFile),
    Video: mediaIdFromForm(Video),
    Images: (Images || []).map((img) => mediaIdFromForm(img)).filter((id) => id != null),
    VideoURL: VideoURL != null && VideoURL !== '' ? String(VideoURL).trim() : null,
    Region,
    District,
    Length,
    Duration,
    VirtualAudioGuideExists: VirtualAudioGuideExists || false,
    Paid: Paid || false,
    PaidAmount: Paid ? (PaidAmount != null && PaidAmount !== '' ? Number(PaidAmount) : null) : null,
    SuitableFor,
    TravelMethod,
    objects: objects || [],
    CoordinateAudioGuides: (CoordinateAudioGuides || []).map((guide) => ({
      Coordinates: guide.Coordinates || '',
      Name: guide.Name || '',
      object: guide.object != null && guide.object !== '' ? guide.object : null,
      subcategory:
        guide.subcategory != null && guide.subcategory !== '' ? guide.subcategory : null,
      AudioFile: guide.AudioFile
        ? typeof guide.AudioFile === 'number'
          ? guide.AudioFile
          : guide.AudioFile && typeof guide.AudioFile.id === 'number'
          ? guide.AudioFile.id
          : null
        : null,
    })).filter((guide) => guide.Coordinates), // Filter out empty entries
  };
};
